import { AuthService } from './../../../core/services/auth-service/auth.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CRegister } from './../../../core/models/login';
import { serverError } from './../../../core/models/messages';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import {
  linkedCompanyRegExp,
  patternEmail,
  patternPassword,
  patternWebsite,
} from './../../../core/models/pattern';
import { MustMatch } from '@core/models/must-match-validator';
import { environment } from './../../../../../src/environment/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent {
  env = environment;
  type = [
    { id: '2', nametype: 'ESN' },
    // { id: '3', nametype: 'CLIENT FINAL' },
    { id: '4', nametype: 'CABINET DE RECRUTEMENT' },
  ];
  typeReadonly = false;
  idCompany: any;
  gettype: any;
  filteredType:any = [];

  message = 'choisir votre type de votre entreprise';
  showName: string = 'name';
  showPassword: string = 'password';
  showConfirmPassword: string = 'password';
  /* boolean */
  loadSpinner: boolean = false;
  /* formGroup */
  generateRegisterForm: FormGroup = this.registerForm(new CRegister({}));
  formcompany!: FormGroup;
  /* object */
  selectedCompany: any;
  term:boolean=false;
  /* unsubscription  */
  private unsubscribeAll: Subject<void> = new Subject();
  isexiste = false;
  selectedType: any;
  previousCompanyName: string | null = null;


  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) {
    this.filteredType =this.type
    this.gettype = false;
    this.selectedType = '';
   }

  /* create register form */
  registerForm(data: CRegister) {
    return this.formBuilder.group({
      name: [data.name, [Validators.required]],
      linkedin_link: [data?.linkedin_link || ''],
      website_link: [data?.website_link || '',
        [Validators.pattern(patternWebsite)]],
      first_name: [
        data.first_name || '', 
        [Validators.required, Validators.pattern(/^[A-Za-zÀ-ÖØ-öø-ÿ'-\s]+$/)]
      ],
      last_name: [
        data.last_name || '', 
        [Validators.required, Validators.pattern(/^[A-Za-zÀ-ÖØ-öø-ÿ'-\s]+$/)]
      ],
      type: [data.type || null, Validators.required],
      email: [
        data.email,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      password: [
        data.password,
        [Validators.required, Validators.pattern(patternPassword)],
      ],
      confirmPassword: [
        data?.confirmPassword,
        [Validators.required, Validators.pattern(patternPassword)],
      ],
      terme: [data.terme, [Validators.required]],
      newsLetter: [data.newsLetter? data.newsLetter : false],
    },
     { validator: MustMatch('password', 'confirmPassword') });
  }
  terms(){
    this.term=this.generateRegisterForm.get("terme")?.value;
  }
  updateFilteredType() {
    if (this.gettype == 2) {
      this.filteredType = this.type.filter((item) => {
        const shouldInclude = item.id !== '3';  // Exclude item with id '3'
        return shouldInclude;
      });
    } else {
      this.filteredType = [...this.type];
    }
  }
  showmsg: boolean = false
  gettypeselect(event: any) {
    if (this.generateRegisterForm.get('type')!.value === null) {
      this.showmsg = true
    }
    else {
      this.showmsg = false
    }
  }
  onTypeChange(event: any) {
    this.filteredType =this.type
    this.generateRegisterForm.patchValue({ type: event.id });
    this.selectedType = event;
  }

  signUp() {
    this.reCaptchaService.executeAction('register').then(token => {
    this.spinner.show();
    if (!this.isexiste) {
      this.setValidatorRequirements();
      this.isexiste = false;
      const payload = {
        ...this.generateRegisterForm.value,
        recaptchaToken: token
      };
      this.authService
        .register(payload)
        .pipe()
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.spinner.hide()
              this.toastrService.success('Inscription réussie');
              this.router.navigate([
                '/auth/code-verification',
                { email: this.generateRegisterForm.value.email },
              ]);
            }
          },
          error: (err) => {
            this.spinner.hide()
            if (err?.error) {
              if (err.error?.message && err.error?.message['email']) {
                this.toastrService.info('Email existe déjà');
              } else if (err.error?.message && err.error?.message['name']) {
                this.toastrService.info("le nom  d'entreprise existe déjà");
              } else if (
                err.error?.message &&
                err.error?.message['linkedin_link']
              ) {
                this.toastrService.info('Le lien LinkedIn existe déjà');
              } else if (
                err.error?.message &&
                err.error?.message['website_link']
              ) {
                this.toastrService.info('Le lien du site web existe déjà');
              } else {
                this.toastrService.error(serverError);
              }
            }
          },
        });
    }
    else {
      let updatedData = {
        idCompany: this.idCompany,
        ...this.generateRegisterForm.value
      };
      this.authService.register(updatedData).subscribe({
        next: (updateRes) => {
          if (updateRes.status == 200) {
            this.spinner.hide()
            this.isexiste = true;
            this.updateFormWithCompanyData(updateRes.data);
            this.selectedCompany = updateRes.data;
            this.toastrService.success('Mise à jour réussie');
            this.router.navigate([
              '/auth/code-verification',
              { email: this.generateRegisterForm.value.email },
            ]);
          }
        },
        error: (updateErr) => {
           this.spinner.hide()
          if (updateErr.error.message === 'user already has a account. ') {
            this.toastrService.error(
              'Ce compte  est déjà utilisé. Veuillez en choisir un autre.'
            );
          }
          if (updateErr?.error) {
           
            if (updateErr.error?.message && updateErr.error?.message['email']) {
              this.toastrService.info('Email existe déjà');
            } else if (
              updateErr.error?.message &&
              updateErr.error?.message['linkedin_link']
            ) {
              this.toastrService.info('Le lien LinkedIn existe déjà');
            } else if (
              updateErr.error?.message &&
              updateErr.error?.message['website_link']
            ) {
              this.toastrService.info('Le lien du site web existe déjà');
            } else if (
              updateErr.error?.message &&
              updateErr.error?.message['name']
            ) {
              this.toastrService.info("le nom  d'entreprise existe déjà");
            }
          }
        },
      });
    }

    }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.');
    });
  }

  setValidatorRequirements() {
    const linkedinLink = this.generateRegisterForm.get('linkedin_link');
    const websiteLink = this.generateRegisterForm.get('website_link');

    linkedinLink?.clearValidators();
    websiteLink?.clearValidators();

    if (!linkedinLink?.value && !websiteLink?.value) {
      linkedinLink?.setValidators([
        Validators.required,
        Validators.pattern(linkedCompanyRegExp),
      ]);
      websiteLink?.setValidators([
        Validators.required,
        Validators.pattern(patternWebsite),
      ]);
    } else {
      if (!linkedinLink?.value) {
        websiteLink?.setValidators([
          Validators.required,
          Validators.pattern(patternWebsite),
        ]);
      }
      if (!websiteLink?.value) {
        linkedinLink?.setValidators([
          Validators.required,
          Validators.pattern(linkedCompanyRegExp),
        ]);
      }
      if (linkedinLink?.value) {
        linkedinLink?.setValidators([
          Validators.pattern(linkedCompanyRegExp),
        ]);
      }
      if (websiteLink?.value) {
        websiteLink?.setValidators([
          Validators.pattern(patternWebsite),
        ]);
      }
    }

    linkedinLink?.updateValueAndValidity();
    websiteLink?.updateValueAndValidity();
  }

  updateFormWithCompanyData(companyData: any) {

    this.generateRegisterForm.patchValue({
      website_link: companyData.website_link,
      linkedin_link: companyData.linkedin_link,
    });

    if (companyData.type == '1') {
      this.typeReadonly = false;
      this.message = 'Choisir votre type de votre entreprise';
      this.selectedType = this.type.find((t) => t?.id === companyData?.type);
    }
    else {
      this.typeReadonly = true;
      this.message = '';
      this.selectedType = this.type.find((t) => t?.id === companyData?.type);
      this.generateRegisterForm.patchValue({
        type: this.selectedType?.id ? this.selectedType?.id : null
      });
    }
  }

  /* unsubscibe */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  onCompanyNameBlur() {
    const currentValue = this.generateRegisterForm.get('name')?.value;    
    if (currentValue && currentValue !== this.previousCompanyName) {

      this.previousCompanyName = currentValue;
      this.authService.getcompanyByname(currentValue).subscribe({
        next: (result) => {
          this.isexiste = true;
          if (result.status === 200) {            
            this.updateFormWithCompanyData(result.data);
            this.selectedCompany = result.data;
            this.idCompany = result.data.uuid;
            this.gettype = result.data.type;
            this.updateFilteredType()
          } else {
            this.resetNotFoundCompany()
          }
        },
        error: (err) => {
          this.resetNotFoundCompany()
        }
      });
    }
  }

  resetNotFoundCompany(){
    this.generateRegisterForm.get('type')?.reset();
    this.generateRegisterForm.get('linkedin_link')?.reset();
    this.generateRegisterForm.get('website_link')?.reset();
    this.filteredType =this.type
    this.isexiste = false;
    this.selectedCompany = null;
    this.typeReadonly = false;
    this.message = '';
    this.gettype = false;
  }
}
